import styles from './styles.module.scss'
import { ReactComponent as Disabled } from 'icons/16pxNoMask/Disabled.svg'

export const DisabledMessage = () => (
  <div className={styles.wrap}>
    <Disabled />
    <span className={'s2 gray1'}>Message disabled</span>
  </div>
)
